import React from 'react';
import styles from "./LinkRadio.module.scss";
import {CustomizedTextField} from 'gui/components/formikCustomInput/FormikCustomInput';
import Radio from 'gui/components/formikRadioInput/components/radio';
import {ReactComponent as FilledRadioCircle} from 'assets/img/filledRadioCircleLink.svg';
import {ReactComponent as EmptyRadioCircle} from 'assets/img/emptyRadioCircleLink.svg';


interface ILinkRadioProps {
  currentPathName?: string;
  labelTrue?: string;
  labelFalse?: string;
  linkTrue?: string;
  linkFalse?: string;
  defaultState?: boolean;
}

const pathCompare = (path1: string, path2: string): boolean => {
  if (path1.length <= 5 || path2.length <= 5) {
    return path1 === path2;
  }
  return path1.startsWith(path2) || path2.startsWith(path1);
};
const LinkRadio = (props: ILinkRadioProps) => {
  let state = props.defaultState;
  if (pathCompare(props.linkTrue, props.currentPathName)) {
    state = true;
  } else if (pathCompare(props.linkFalse, props.currentPathName)) {
    state = false;
  }
  return (
    <CustomizedTextField
      className={styles.container}
      inputComponent={inputProps => <Radio
        state={state}
        labelTrue={props.labelTrue}
        labelFalse={props.labelFalse}
        radioSelectedIcon={FilledRadioCircle}
        radioNotSelectedIcon={EmptyRadioCircle}
        linkTrue={props.linkTrue}
        linkFalse={props.linkFalse}
      />}
    />
  );
};

export default LinkRadio;
